import { Input } from "../input";
import Select from "../select";

const HomeAddress = (props) => {
  if (!props) {
    return null;
  }

  const {
    countries,
    textsMapping,
    getPersonalAddressDetails,
    defaultCountryRadioButtonChanged,
    defaultCountry,
    customerAddressNotFoundErrorMessage,
  } = props;

  return (
    <section className="checkout-section home-address">
      <h3 className="checkout-section__title">
        {textsMapping.homeAddressTitle}
      </h3>
      <p>{textsMapping.homeAddressText}</p>

      <Input
        inputType="radio"
        radioGroupName="defaultCountry"
        radioButtons={[
          { name: textsMapping.countryRadioButtonNetherlands, value: true },
          { name: textsMapping.countryRadioButtonOther, value: false },
        ]}
        defaultValue={true}
        path="customerData.address.defaultCountry"
        classNames="grid-cell-6"
        onChangeFunction={defaultCountryRadioButtonChanged}
      />

      {!defaultCountry ? (
        <Select
          resourcedTexts={textsMapping}
          inputLabel={textsMapping.homeAddressCountryLabel}
          options={countries}
          path="customerData.address.country"
          placeHolder={textsMapping.countrySelectDefaultValue}
          required
        />
      ) : null}

      <Input
        resourcedTexts={textsMapping}
        inputType="text"
        inputLabel={textsMapping.homeAddressZipLabel}
        placeHolder={textsMapping.homeAddressZipPlaceholder}
        onBlurFunction={getPersonalAddressDetails}
        path="customerData.address.zip"
        classNames="grid-cell-3"
        required
      />

      <Input
        resourcedTexts={textsMapping}
        inputType="number"
        inputLabel={textsMapping.homeAddressHouseNumberLabel}
        placeHolder={textsMapping.homeAddressHouseNumberPlaceholder}
        onBlurFunction={getPersonalAddressDetails}
        path="customerData.address.houseNumber"
        classNames="grid-cell-3"
        required
      />

      <Input
        resourcedTexts={textsMapping}
        inputType="text"
        inputLabel={textsMapping.homeAddressHouseNumberAdditionLabel}
        placeHolder={textsMapping.homeAddressHouseNumberAdditionPlaceholder}
        path="customerData.address.houseNumberAddition"
        classNames="grid-cell-3"
      />

      <Input
        resourcedTexts={textsMapping}
        inputType="text"
        inputLabel={textsMapping.homeAddressStreetLabel}
        placeHolder={textsMapping.homeAddressStreetPlaceholder}
        path="customerData.address.street"
        required
      />

      <Input
        resourcedTexts={textsMapping}
        inputType="text"
        inputLabel={textsMapping.homeAddressCityLabel}
        placeHolder={textsMapping.homeAddressCityPlaceholder}
        path="customerData.address.city"
        required
      />

      {customerAddressNotFoundErrorMessage && (
        <p className="address-error-messsage">
          {customerAddressNotFoundErrorMessage}
        </p>
      )}
    </section>
  );
};

export default HomeAddress;
